export default "__VITE_ASSET__DGtTZoS7__"